import { render } from "./StaticDisplay.vue?vue&type=template&id=d058f418&scoped=true"
import script from "./StaticDisplay.vue?vue&type=script&lang=js"
export * from "./StaticDisplay.vue?vue&type=script&lang=js"

import "./StaticDisplay.vue?vue&type=style&index=0&id=d058f418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d058f418"]])

export default __exports__